import { maskZipCode } from './masks';

/**
 * Normaliza resposta de GET /api/enderecos/:id/por-id para exibição
 * (mesmo mapeamento usado em EmployeeForm após addressService.getById).
 * @param {Object|null|undefined} api
 * @returns {Object|null}
 */
export function mapAddressFromApi(api) {
    if (!api || typeof api !== 'object') return null;
    return {
        zipCode: api.zipCode ?? '',
        street: api.street ?? '',
        number: api.number != null && api.number !== '' ? String(api.number) : '',
        complement: api.complement ?? '',
        district: api.district ?? '',
        city: api.city ?? '',
        stateAbbr: api.state?.abbreviation ?? '',
        stateName: api.state?.name ?? '',
        addressId: api.id ?? null,
    };
}

/**
 * CEP para leitura (máscara ou em dash).
 * @param {string|number|null|undefined} raw
 * @returns {string}
 */
export function formatZipDisplay(raw) {
    if (raw == null || raw === '') return '—';
    const d = String(raw).replace(/\D/g, '');
    return d.length ? maskZipCode(d) : '—';
}
